import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-hot-toast';

const buildTime = import.meta.env.VITE_BUILD_TIME;

export default function useAutoUpdate() {
  const location = useLocation();
  const checkRef = useRef(null);

  useEffect(() => {
    if (!import.meta.env.PROD || !buildTime) return;
    let disposed = false;
    let controller;
    let reloadTimer;
    const check = async () => {
      if (controller || reloadTimer || disposed) return;
      controller = new AbortController();
      const timeout = window.setTimeout(() => controller?.abort(), 15000);
      try {
        const response = await fetch(`/version.json?t=${Date.now()}`, {
          cache: 'no-store', signal: controller.signal
        });
        if (!response.ok) return;
        const version = await response.json();
        if (!disposed && typeof version.buildTime === 'string' && Number.isFinite(Date.parse(version.buildTime)) && version.buildTime !== buildTime) {
          toast('Yeni bir güncelleme mevcut, sayfa yenileniyor...', { id: 'app-update', duration: 3000 });
          reloadTimer = window.setTimeout(() => window.location.reload(), 3000);
        }
      } catch {
        // Offline, unavailable or invalid version responses are retried at the next check.
      } finally {
        window.clearTimeout(timeout);
        controller = undefined;
      }
    };
    checkRef.current = check;
    const interval = window.setInterval(check, 5 * 60 * 1000);
    check();
    return () => {
      disposed = true;
      checkRef.current = null;
      controller?.abort();
      window.clearInterval(interval);
      window.clearTimeout(reloadTimer);
      toast.dismiss('app-update');
    };
  }, []);

  useEffect(() => {
    checkRef.current?.();
  }, [location]);
}
